import { useState, useEffect } from 'react';

import { fetchFeaturedCarousel, fetchFeaturedCarouselPreview, fetchFeaturedFantasyVerseCarousel } from 'Redux/ducks/algolia-calls';
import getUrlParameter from 'Helpers/Url/GetUrlParameter';

const useFetchCarouselSlides = ({ fantasyVerse, isPreview }) => {
  const [apiResults, setApiResults] = useState([]);
  const [fetchError, setFetchError] = useState(null);

  const urlParamStartDate = getUrlParameter('startDate');

  useEffect(() => {
    if (fantasyVerse) {
      fetchFeaturedFantasyVerseCarousel().then(setApiResults).catch(
        error => setFetchError(error),
      );
    } else if (isPreview) {
      fetchFeaturedCarouselPreview(urlParamStartDate).then(setApiResults).catch(
        error => setFetchError(error),
      );
    } else {
      fetchFeaturedCarousel().then(setApiResults).catch(
        error => setFetchError(error),
      );
    }
  }, [fantasyVerse, isPreview, urlParamStartDate]);

  if (fetchError) {
    window.prerenderReady = true;
    throw fetchError;
  }

  return { apiResults };
};

export default useFetchCarouselSlides;
